import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Mail, Check, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Unsubscribe = () => {
  const [params] = useSearchParams();
  const email = params.get('email') || '';
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!email) { setStatus('error'); return; }
    axios.get(`${API}/newsletter/unsubscribe`, { params: { email } })
      .then(() => setStatus('done'))
      .catch(() => setStatus('done')); // still show success since backend is idempotent
  }, [email]);

  return (
    <div className="min-h-screen bg-[#FDFBF8] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center py-16">
        {status === 'loading' ? (
          <>
            <Loader2 className="w-8 h-8 mx-auto animate-spin text-stone-400 mb-4" />
            <p className="text-sm font-sans text-stone-500">Unsubscribing...</p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-stone-100 flex items-center justify-center">
              <Check className="w-8 h-8 text-stone-500" />
            </div>
            <h1 className="font-serif text-2xl font-bold text-stone-900 mb-3">Unsubscribed</h1>
            <p className="text-sm font-sans text-stone-500 mb-8 leading-relaxed">
              {email ? (
                <>You will no longer receive marketing emails from Lumera at <strong>{email}</strong>.</>
              ) : (
                'You have been unsubscribed from marketing emails.'
              )}
            </p>
            <p className="text-xs font-sans text-stone-400 mb-6">
              You will still receive important transactional emails such as purchase confirmations.
            </p>
            <Button
              onClick={() => window.location.href = '/'}
              variant="outline"
              className="rounded-xl px-6 py-2.5 text-sm font-sans"
            >
              Back to Lumera
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;
